// src/app/base/base.component.ts
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PermissionConstants as Permissions } from 'src/app/constants/permissions';

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BaseComponent {
  public permissions = Permissions;
}
